import React from 'react';
import { Navigate } from 'react-router';

const Callback = (props) => (<Navigate to={props.redirectURL ?? '/'} replace />);

export default Callback;
